import type { SVGProps } from 'react';
const SvgSportsFootball = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sports_football_svg__a)">
      <path d="M3.02 15.62c-.08 2.42.32 4.34.67 4.69.35.35 2.28.76 4.69.67l-5.36-5.36ZM13.08 3.28c-2.33.42-4.79 1.34-6.62 3.18s-2.76 4.29-3.18 6.62l7.63 7.63c2.34-.41 4.79-1.34 6.62-3.18s2.76-4.29 3.18-6.62l-7.63-7.63ZM9.9 15.5l-1.4-1.4 5.6-5.6 1.4 1.4-5.6 5.6ZM20.98 8.38c.08-2.42-.32-4.34-.67-4.69-.35-.35-2.28-.76-4.69-.67l5.36 5.36Z" />
    </g>
    <defs>
      <clipPath id="sports_football_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSportsFootball;
